import { supabase } from "@/integrations/supabase/client";

export async function advanceStep(userId: string, nodeId: string, newIndex: number) {
  const { error } = await supabase
    .from("user_node_progress")
    .update({ current_step_index: newIndex })
    .eq("user_id", userId)
    .eq("node_id", nodeId);
  if (error) throw error;
}

export async function completeNode(
  userId: string,
  nodeId: string,
  courseId: string,
  xpEarned: number,
) {
  // Mark node completed
  const { error: nodeErr } = await supabase
    .from("user_node_progress")
    .update({
      status: "completed",
      completed_at: new Date().toISOString(),
      xp_earned: xpEarned,
    })
    .eq("user_id", userId)
    .eq("node_id", nodeId);
  if (nodeErr) throw nodeErr;

  // Increment course progress
  const { data: cp, error: cpErr } = await supabase
    .from("user_course_progress")
    .select("completed_nodes, total_xp")
    .eq("user_id", userId)
    .eq("course_id", courseId)
    .single();
  if (cpErr) throw cpErr;

  const { error: upErr } = await supabase
    .from("user_course_progress")
    .update({
      completed_nodes: (cp.completed_nodes ?? 0) + 1,
      total_xp: (cp.total_xp ?? 0) + xpEarned,
      last_active_at: new Date().toISOString(),
    })
    .eq("user_id", userId)
    .eq("course_id", courseId);
  if (upErr) throw upErr;
}

export async function recordXp(
  userId: string,
  courseId: string,
  nodeId: string,
  xpAmount: number,
  eventType: "question_correct" | "lesson_complete" | "review_complete",
) {
  const { error } = await supabase.from("xp_events").insert({
    user_id: userId,
    course_id: courseId,
    node_id: nodeId,
    xp_amount: xpAmount,
    event_type: eventType,
  });
  if (error) throw error;
}
